/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

const addToCartAndOpenDrawer = async (variantId) => {
    try {
        const cartDrawerEl = document.querySelector('cart-drawer');
        const pageHeaderEl = document.querySelector('page-header');
        const sectionsToUpdate = [pageHeaderEl, cartDrawerEl].filter(Boolean);
        const sectionIds = sectionsToUpdate.map((s) => s.dataset.sectionId);

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sectionIds.join(','));

        const response = await fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        });

        if (!response.ok) throw new Error(`Cart error: ${response.status}`);

        const data = await response.json();

        if (data.sections) {
            sectionsToUpdate.forEach((sectionEl) => {
                const html = data.sections[sectionEl.dataset.sectionId];
                if (html) sectionEl.updateFromCartChange(html);
            });
        }

        document.querySelector('.js-cart-drawer')?.open();

    } catch (err) {
        console.error('[QuickAddDesktop]', err);
    }
};

const initQuickAddDesktop = () => {
    document.addEventListener('click', async (e) => {
        const label = e.target.closest('quick-add-to-cart-desktop .opt-label');
        if (label) {
            const container = label.closest('.quick-add-to-cart-container.desktop');
            if (!container) return;

            const radio = container.querySelector(`#${label.htmlFor}`);
            if (!radio) return;

            const variantData = JSON.parse(
                container.querySelector('variant-picker script[type="application/json"]').textContent
            );
            const variant = variantData.variants.find((v) => v.options[0] === radio.value);
            if (!variant?.available) return;

            await addToCartAndOpenDrawer(variant.id);
            return;
        }

        const addBtn = e.target.closest('quick-add-to-cart-desktop [data-quick-add-btn-simple-product]');
        if (addBtn) {
            const container = addBtn.closest('.quick-add-to-cart-container.simple-product');
            if (!container) return;

            const variantId = container.dataset.variantId;
            if (!variantId) return;

            addBtn.disabled = true;
            addBtn.classList.add('is-loading');
            await addToCartAndOpenDrawer(variantId);
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
            return;
        }
    });
};

if (!window.__quickAddDesktopInit) {
    window.__quickAddDesktopInit = true;
    initQuickAddDesktop();
}